module.exports = __webpack_public_path__ + "fonts/InstagramSansCondensed-Regular.18081e0b.woff";